/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import fetchIntercept from 'fetch-intercept';
import { ActionTypes } from '@/login/state';
import { Routes } from '../constants/routes';

let unregister: any;
const STATUS_CODE_200 = 200;
const STATUS_CODE_401 = 401;

export const setAuthToken = (store: any) => {
  if (unregister) {
    unregister();
  }
  unregister = fetchIntercept.register({
    request(url, config = {}) {
      if (typeof url !== 'string') {
        return [url, config];
      }
      const isDD = url.includes('datadoghq');
      const isKeyKloack = url.includes('realms');
      const accessToken = sessionStorage.getItem('accessToken');
      if (accessToken && !isDD) {
        if (!config.headers) {
          config.headers = {};
        }
        if (config.headers['Content-Type'] === 'multipart/form-data') {
          delete config.headers['Content-Type'];
        }
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      if (config.credentials) {
        delete config.credentials;
      }

      if (!isKeyKloack && !isDD) {
        config.headers['X-Timezone-Info'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        config.headers['X-Active-Role'] = window.localStorage.getItem('currentRole');
        config.headers['X-Active-Context'] = window.localStorage.getItem('activeContext');
      }

      return [url, config];
    },
    response(response) {
      if (
        response.request.url.includes('/protocol/openid-connect/token') &&
        response &&
        response.body
      ) {
        if (response.status !== STATUS_CODE_200) {
          store.dispatch({ type: ActionTypes.CLEAN_LOGGED_USER });
          sessionStorage.removeItem('accessToken');
          window.location.href = window.location.origin + Routes.Login;
          return response;
        }
        const user = response?.clone().json();
        user.then(data => {
          sessionStorage.setItem('accessToken', data?.access_token);
          store.dispatch({ type: ActionTypes.SET_LOGGED_USER, payload: data });
        });
      }

      if (response.status === STATUS_CODE_401) {
        return response;
      }

      return response;
    },
  });
};
